import React, {useEffect, useState} from 'react'
import {ProjectGuestPortalClient} from '../../infrastracture/api/ProjectGuestPortalClient'
import {useProjectGuest} from './ProjectGuestContext'

export function ProjectGuestTeam() {
  const {selectedProjectId, loading: projectsLoading} = useProjectGuest()
  const [users, setUsers] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!selectedProjectId) {
      setLoading(false)
      return
    }

    let cancelled = false
    setLoading(true)
    ProjectGuestPortalClient.GetProject(selectedProjectId).then((response) => {
      if (cancelled) return
      if (response.successful) setUsers(response.data?.users || [])
      setLoading(false)
    })

    return () => {
      cancelled = true
    }
  }, [selectedProjectId])

  return (
    <div className='card'>
      <div className='card-header'>
        <div className='card-title'>
          <h3>{"Who's On"}</h3>
        </div>
      </div>
      <div className='card-body py-3'>
        <div className='table-responsive'>
          <table className='table align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bold text-muted bg-light'>
                <th className='ps-4 min-w-200px rounded-start'>Name</th>
                <th className='min-w-150px'>Role</th>
                <th className='min-w-150px rounded-end'>Today</th>
              </tr>
            </thead>
            <tbody>
              {!projectsLoading &&
                !loading &&
                users.map((user: any) => (
                  <tr key={user.id}>
                    <td className='ps-4'>{user.userName}</td>
                    <td>{user.projectRoleName || '—'}</td>
                    <td>
                      {user.todayAssetName || <span className='text-muted'>Not checked in</span>}
                    </td>
                  </tr>
                ))}
              {!projectsLoading && !loading && users.length === 0 && (
                <tr>
                  <td colSpan={3} className='text-center text-muted py-5'>
                    No team members found
                  </td>
                </tr>
              )}
              {(projectsLoading || loading) && (
                <tr>
                  <td colSpan={3} className='text-center text-muted py-5'>
                    Loading...
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
